import Repository from './Repository'

const resource = 'horse-shoe-works'

export default {
  getHorseshoeWorks (tenantId, params) {
    return Repository.get(`tenants/${tenantId}/${resource}`, { params: params })
  }
}
